module.exports = "/_next/static/images/KevinBrophy-51da82ef73d1ce70f9e72efbf1645b3a.webp";